import React from "react";

import excitementIcon from "src/static/img/postRsvp/icons/excitement.svg";
import forestIcon from "src/static/img/postRsvp/icons/forest.svg";
import ginnyIcon from "src/static/img/postRsvp/icons/ginny-icon.png";
import inAweIcon from "src/static/img/postRsvp/icons/in-awe.svg";
import instrumentIcon from "src/static/img/postRsvp/icons/instrument.svg";
import landscapeIcon from "src/static/img/postRsvp/icons/landscape.svg";
import mountainsIcon from "src/static/img/postRsvp/icons/mountains.svg";
import musicIcon from "src/static/img/postRsvp/icons/music.svg";
import nighttimeIcon from "src/static/img/postRsvp/icons/nighttime.svg";
import patchIcon from "src/static/img/postRsvp/icons/patch-icon.png";
import plantIcon from "src/static/img/postRsvp/icons/plant.svg";
import portraitIcon from "src/static/img/postRsvp/icons/portrait.svg";
import readyForANapIcon from "src/static/img/postRsvp/icons/ready-for-a-nap.svg";
import sparklesIcon from "src/static/img/postRsvp/icons/sparkles.svg";
import squareIcon from "src/static/img/postRsvp/icons/square.svg";
import theUsualIcon from "src/static/img/postRsvp/icons/the-usual.svg";
import vinylIcon from "src/static/img/postRsvp/icons/vinyl-icon.png";
import wrenchIcon from "src/static/img/postRsvp/icons/wrench.svg";

type IconProps = { className?: string };

const OptionImg: React.FC<IconProps & { src: string; alt?: string }> = ({
  src,
  className,
  alt = "",
}) => (
  <img
    src={src}
    alt={alt}
    aria-hidden
    draggable={false}
    className={className}
    style={{ width: 20, height: 20, objectFit: "contain", display: "block" }}
  />
);

export const SquareIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={squareIcon} {...props} />
);
export const PortraitIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={portraitIcon} {...props} />
);
export const LandscapeIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={landscapeIcon} {...props} />
);
export const NighttimeIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={nighttimeIcon} {...props} />
);
export const ForestIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={forestIcon} {...props} />
);
export const MountainsIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={mountainsIcon} {...props} />
);
export const UsualIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={theUsualIcon} {...props} />
);
export const InAweIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={inAweIcon} {...props} />
);
export const SnoozeIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={readyForANapIcon} {...props} />
);
export const InstrumentIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={instrumentIcon} {...props} />
);
export const PlantIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={plantIcon} {...props} />
);
export const WrenchIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={wrenchIcon} {...props} />
);
export const ExcitementIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={excitementIcon} {...props} />
);
export const MusicIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={musicIcon} {...props} />
);
export const SparklesIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={sparklesIcon} {...props} />
);

export const GinnyIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={ginnyIcon} {...props} />
);
export const PatchIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={patchIcon} {...props} />
);
export const VinylIcon: React.FC<IconProps> = (props) => (
  <OptionImg src={vinylIcon} {...props} />
);
